// extracted by mini-css-extract-plugin
export default {"modal":"iO-z","modalOverlay":"jO-z","outfitHeading":"kO-z"};